<template>
  <div class="services">
    <h2 class="main-cl services-title">{{ $t('homeTemplate.services.text_1') }}</h2>
    <p class="gray-cl services-des">{{ $t('homeTemplate.services.text_2') }}</p>
    <div class="service-list">
      <dl
        class="item-service"
        v-for="(item, index) in serviceList"
        :key="index"
        :class="item.isHover ? 'blue-cl blue-10-bg' : 'main-cl'"
        @mouseenter="mouseenterItem(item)"
        @mouseleave="mouseleaveItem(item)"
      >
        <dt>
          <svg-icon :iconClass="item.icon" class="item-icon"></svg-icon>
        </dt>
        <dd>
          <div class="item-title">{{ item.title }}</div>
          <div class="item-des">{{ item.des }}</div>
        </dd>
      </dl>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      serviceList: [
        {
          title: this.$t('homeTemplate.services.text_3'),
          des: this.$t('homeTemplate.services.text_4'),
          icon: 'service-one',
          isHover: false,
        },
        {
          title: this.$t('homeTemplate.services.text_5'),
          des: this.$t('homeTemplate.services.text_6'),
          icon: 'service-two',
          isHover: false,
        },
        {
          title: this.$t('homeTemplate.services.text_7'),
          des: this.$t('homeTemplate.services.text_8'),
          icon: 'service-three',
          isHover: false,
        },
        {
          title: this.$t('homeTemplate.services.text_9'),
          des: this.$t('homeTemplate.services.text_10'),
          icon: 'service-four',
          isHover: false,
        },
      ],
    };
  },
  methods: {
    mouseenterItem(item) {
      item.isHover = true;
    },
    mouseleaveItem(item) {
      item.isHover = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.services {
  margin-top: 100px;
}
.services-title {
  font-size: 36px;
  line-height: 58px;
  margin-bottom: 8px;
  font-weight: 600;
}
.services-des {
  font-size: 16px;
  line-height: 26px;
  letter-spacing: 0.01em;
  margin-bottom: 97px;
}
.service-list {
  display: flex;
  flex-wrap: wrap;
  .item-service {
    width: 50%;
    padding: 23px 44px;
    box-sizing: border-box;
    overflow: hidden;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    margin-bottom: 34px;
    cursor: pointer;
    border-radius: 16px;
    transition: all .5s ease-out;
    &:nth-child(2n - 1) {
      padding-right: 50px;
    }
    &:nth-child(2n) {
      padding-left: 50px;
    }
    .item-icon {
      font-size: 80px;
      margin-right: 45px;
    }
    .item-title {
      font-size: 30px;
      line-height: 48px;
      margin-bottom: 8px;
    }
    .item-des {
      font-size: 20px;
      line-height: 32px;
    }
  }
}
</style>
